module.exports = __webpack_public_path__ + "asset/img/video-placeholder.3fad75aedd214d1ff7275892684b326f.png";